export default function ContentTitle({ title, headerElement, className }) {
    return (
        <>
            {(title || headerElement) && (
                <div className={`flex justify-content-between items-center mb-4 ${className}`}>
                    {title && 
                        <h1 className="text-xl font-medium">
                            {title}
                        </h1>
                    }
                    {headerElement && headerElement}
                </div>
            )}
        </>
    );
}